import { Label, cn } from '@repo/ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

import type { LabelProps } from '@radix-ui/react-label'

type Props = LabelProps & {
  children: React.ReactNode
  labelText: string
  error?: string
  className?: string
  labelClassName?: string
}

function FormControl({
  children,
  labelText,
  error,
  className,
  labelClassName,
  ...props
}: Props) {
  const { t } = useTranslation()

  return (
    <div className={cn('', className)}>
      <Label
        {...props}
        className={cn(
          'text-muted-foreground mb-2 text-sm md:text-base',
          labelClassName,
        )}
      >
        {labelText}
      </Label>
      {children}
      {error && <p className="form-error-message">{t(error)}</p>}
    </div>
  )
}

export default FormControl
